import { Constructor, Tuple } from '@skylab-shared/types';
import { ModelBase } from './model-base';
import { ModelMetadataContainer } from './model-metadata-container';
import { PropertyConfig, PropertyMetadata } from './property-metadata';

export type PropertyType<TModel extends ModelBase> = Tuple<Constructor<TModel>, keyof TModel>;

export function Property(): PropertyDecorator;
export function Property(config: Partial<PropertyConfig>): PropertyDecorator;
export function Property(type: Constructor<any>): PropertyDecorator;
export function Property(type: Constructor<any>, config: Partial<PropertyConfig>): PropertyDecorator;
export function Property(typeOrConfig?: any, configOrNothing = {}): PropertyDecorator {
    return (target: any, propertyKey: string | symbol): void => {
        const key = propertyKey as string;
        // obejście: https://github.com/rbuckton/reflect-metadata/issues/84
        const reflectedMetadataType = typeOrConfig instanceof Function ? typeOrConfig : Reflect.getMetadata('design:type', target, key);
        const config = typeOrConfig instanceof Object && !(typeOrConfig instanceof Function) ? typeOrConfig : configOrNothing;
        const propertyMetadata: PropertyMetadata = {
            propertyName: key,
            type: reflectedMetadataType,
            config: {
                type: undefined,
                serializable: true,
                identifiable: false,
                nullable: Object.getPrototypeOf(reflectedMetadataType) === ModelBase,
                ...config
            } as const
        };

        const modelMetadata: ModelMetadataContainer = Reflect.getMetadata('skl:model', target.constructor) || new ModelMetadataContainer();

        modelMetadata.setPropertyMetadata(key, propertyMetadata);

        Reflect.defineMetadata('skl:model', modelMetadata, target.constructor);
    };
}
